import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import './OurTeam.css';

import exec1 from '../assets/2022-23 Exec.jpg';
import exec2 from '../assets/2023-24 Exec.jpg';
import exec3 from '../assets/2024-25 Exec.jpg';
import exec4 from '../assets/2024-25 CCBF.jpg'
import exec5 from '../assets/2025-26 Exec.jpg';
import exec6 from '../assets/2026-27 Exec.jpg';

import Arshjot from '../assets/current-exec/Arshjot.jpg';
import Diya from '../assets/current-exec/Diya.jpg';
import Elina from '../assets/current-exec/Elina.png';
import Hajira from '../assets/current-exec/Hajira.jpg';
import Jessie from '../assets/current-exec/Jessie.png';
import Kimberly from '../assets/current-exec/Kimberly.JPG';
import Laiba from '../assets/current-exec/Laiba.jpeg';
import Lauren from '../assets/current-exec/Lauren.jpg';
import Prabhleen from '../assets/current-exec/Prabhleen.PNG';
import Ria from '../assets/current-exec/Ria.png';
import Sameen from '../assets/current-exec/Sameen.png';
import Sanaa from '../assets/current-exec/Sanaa.jpg';
import Simran from '../assets/current-exec/Simran.jpg';
import Wangxin from '../assets/current-exec/Wangxin.jpg';
import William from '../assets/current-exec/William.png';
import Zoey from '../assets/current-exec/Zoey.png';

export default function OurTeam() {
  const [portfolio, setPortfolio] = useState('All');
  const [selectedMember, setSelectedMember] = useState(null);

  const portfolioDescriptions = {
    All: 'Meet the executives for the 2026-27 school year.',
    'Community Relations': 'The Community Relations portfolio focuses on connecting students and parents through workshops and events.',
    Marketing: 'The Marketing portfolio promotes our events and opportunities, ensuring our opportunities reach students, parents, teachers, and volunteers.',
    Operations: 'The Operations portfolio handles the logistics including tutor-tutee pairings and program execution.'
  };

  const teamMembers = [
    {
      name: 'Sameen Sadaf',
      portfolio: 'Marketing',
      roles: ['Co-Founder', 'Director of Marketing'],
      img: Sameen,
      desc: 'Sameen is a PharmD student at the University of Alberta who proudly co-founded Life Long Learners in 2020. With a passion for supporting young learners in their path to success, her aim is to provide accessible tutoring services for students across EPSB, empowering them in their academic journey.'
    },
    {
      name: 'Sanaa Bhaidani',
      portfolio: 'Community Relations',
      roles: ['Co-Founder', 'Director of Community Relations'],
      img: Sanaa,
      desc: 'Sanaa is in her final year of Software Engineering at the University of Alberta. As a tutor and student, she recognizes the importance of having the necessary tools to reach your academic potential, and through Life Long Learners, strives to provide these resources to students seeking it.'
    },
    {
      name: 'Simran Dhaliwal',
      portfolio: 'Operations',
      roles: ['Co-Founder', 'Director of Operations'],
      img: Simran,
      desc: 'Simran is a Bachelor of Science graduate with a Specialization in Psychology from the University of Alberta. Passionate about growth and equity in education, she co-founded Life Long Learners in 2020 and remains committed to continuously improving the program to support young students through accessible, personalized peer support. '
    },
    {
      name: 'Laiba Inam',
      portfolio: 'Community Relations',
      roles: ['Incoming Director of Community Relations'],
      img: Laiba,
      desc: 'Laiba is a first-year student in the University of Alberta’s Kinesiology department. With her past experience as both a tutee and tutor, she hopes to bring in a diverse perspective to the Director of Community Relations role and build long-lasting connections through unforgettable events.'
    },
    {
      name: 'Prabhleen Gill',
      portfolio: ['Operations', 'Community Relations'],
      roles: ['Incoming Director of Operations', 'Assistant Director of Finance'],
      img: Prabhleen,
      desc: 'Prabhleen is an Immunology and Infection student at the University of Alberta. She hopes to utilize her experiences to foster a collaborative environment and support the organization in driving academic growth in the community as an AD Finance and the incoming Director of Operations.'
    },
    {
      name: 'Zoey Paul',
      portfolio: 'Marketing',
      roles: ['Incoming Director of Marketing', 'Assistant Director of Outreach'],
      img: Zoey,
      desc: 'Zoey is a first-year sciences student at the University of Alberta. As a previous tutor for Life Long Learners over many years, she is excited to expand the program to our growing community through dedicated outreach. Zoey looks forward to fostering new community partnerships and working with our empowering team, as an AD Outreach.'
    },
    {
      name: 'Arshjot Kaur',
      portfolio: 'Community Relations',
      roles: ['Assistant Director of Events'],
      img: Arshjot,
      desc: 'Arshjot is a Neuroscience student at the University of Alberta. As a previous tutor and current AD Events, she has supported the growth of young learners through science experiments and student panels that enrich their educational journeys. With a focus on community and compassion, she is excited to continue planning curious and insightful events to bring together our wonderful tutors and tutees!'
    },
    {
      name: 'Diya Patel',
      portfolio: 'Operations',
      roles: ['Assistant Director of Tutoring'],
      img: Diya,
      desc: 'Diya is an Immunology student at the University of Alberta. As a previous tutor, and now assistant director of operations for the Life Long Learners team, she is committed to enhancing operational workflows and ensuring high standards of service delivery across all levels of the organization. She is determined and looking forward to making this journey one of continuous improvement!'
    },
    {
      name: 'Elina Ajamian',
      portfolio: 'Community Relations',
      roles: ['Assistant Director of Events'],
      img: Elina,
      desc: 'Elina is a Psychology student at the University of Alberta and has been part of the team since 2021. As AD Events, she hopes to enhance the tutoring experience and nurture tutor-tutee bonds through fun and interactive events. She cannot wait to see how the program grows :).'
    },
    {
      name: 'Hajira Penukonda',
      portfolio: 'Community Relations',
      roles: ['Assistant Director of Finance'],
      img: Hajira,
      desc: 'Hajira is a Grade 12 student at Old Scona Academic. After two years as a tutor for Life Long Learners, she looks forward to helping the organization secure resources to support its future growth as she steps into the role of Assistant Director of Finance. Passionate about accessible STEM education, she hopes to expand opportunities and inspire more students to pursue their potential.'
    },
    {
      name: 'Jessie Song',
      portfolio: 'Marketing',
      roles: ['Assistant Director of Promotions'],
      img: Jessie,
      desc: 'Jessie is a Nursing student at the University of Alberta. As both a tutor and AD for Life Long Learners previously, she is eager to continue her role of promoting the program to the community. Jessie looks forward to creating engaging content, managing online interactions, and connecting students with the academic support they need.'
    },
    {
      name: 'Kimberly Mah',
      portfolio: 'Operations',
      roles: ['Assistant Director of Tutoring'],
      img: Kimberly,
      desc: 'Kimberly is a Biological Sciences student at the University of Alberta. She has been tutoring with Life Long Learners since 2024. As AD Tutoring Coordinator she hopes to continue to make a positive impact on students’ lives. She hopes to foster connection, cooperation and enthusiasm for learning!'
    },
    {
      name: 'Lauren Alphonso',
      portfolio: 'Community Relations',
      roles: ['Assistant Director of Events'],
      img: Lauren,
      desc: 'Lauren is a 4th year Psychology student at the University of Alberta. She is excited to continue working with the team, and using her skills to help with events! She looks forward to planning various events to help broaden and strengthen the curiosity of many.'
    },
    {
      name: 'Ria Joshi',
      portfolio: 'Operations',
      roles: ['Assistant Director of Tutoring'],
      img: Ria,
      desc: 'Ria is a Nursing student at the University of Alberta. As the Assistant Director of Tutoring at Life Long Learners, Ria is passionate about fostering meaningful connections between tutors and students. With a strong background in mentorship and community involvement, she is committed to creating a supportive, inclusive, and effective tutoring environment that helps students thrive.'
    },
    {
      name: 'Wangxin Yu',
      portfolio: 'Marketing',
      roles: ['Assistant Director of Promotions'],
      img: Wangxin,
      desc: 'Wangxin is a Grade 12 student at Old Scona High School. As assistant director of marketing and a previous tutor, she hopes to promote and build recognition for the organization as well as engage the community and help more people connect with the services. '
    },
    {
      name: 'William Ye',
      portfolio: 'Marketing',
      roles: ['Assistant Director of Outreach'],
      img: William,
      desc: 'William is a Grade 12 student at Old Scona Academic. As Assistant Director of Outreach, he is passionate about making tutoring opportunities accessible and creating opportunities for meaningful learning. He is excited to build lasting connections and support volunteers in making a positive difference.'
    }
  ];

  const filteredMembers =
    portfolio === 'All'
      ? teamMembers
      : teamMembers.filter((m) =>
          Array.isArray(m.portfolio) ? m.portfolio.includes(portfolio) : m.portfolio === portfolio
        );

  return (
    <div style={{ width: '100%' }}>
      {/* Hero Section */}
      <div style={{ position: 'relative', width: '100%', height: '80vh', overflow: 'hidden' }}>
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop
          style={{ width: '100%', height: '100%' }}
        >
          {[exec1, exec2, exec3, exec4, exec5, exec6].map((img, i) => (
            <SwiperSlide key={i}>
              <img
                src={img}
                alt={`Exec Team ${i + 1}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#4AA4AD',
            textAlign: 'center',
            zIndex: 1
          }}
        >
          <h1 style={{ fontSize: '3rem', fontWeight: 'bold' }}>Our Team</h1>
        </div>
      </div>

      {/* Filter + Description + Cards */}
      <div className="team-container">
        <div className="team-filter">
          {['All', 'Community Relations', 'Marketing', 'Operations'].map((p) => (
            <button
              key={p}
              onClick={() => setPortfolio(p)}
              className={portfolio === p ? 'active' : ''}
            >
              {p}
            </button>
          ))}
        </div>

        {/* Portfolio Description with smooth fade */}
        <motion.div
          key={portfolio}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3 }}
          style={{ textAlign: 'center', marginBottom: '2rem', color: '#4AA4AD', fontSize: '1rem' }}
        >
          {portfolioDescriptions[portfolio]}
        </motion.div>

        <motion.div
          className="team-grid"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {filteredMembers.map((member, idx) => (
            <motion.div
              key={idx}
              className="team-card"
              whileHover={{ scale: 1.05 }}
              onClick={() => setSelectedMember(member)}
            >
              <img src={member.img} alt={member.name} />
              <h4 className="team-name">{member.name}</h4>
              <div className="team-roles">
                {member.roles.map((role, i) => (
                  <p key={i}>{role}</p>
                ))}
              </div>
              <p className="team-desc">{member.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Modal Popup */}
      {selectedMember && (
        <div className="modal-overlay" onClick={() => setSelectedMember(null)}>
          <motion.div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <button className="modal-close" onClick={() => setSelectedMember(null)}>×</button>
            <img src={selectedMember.img} alt={selectedMember.name} />
            <h2>{selectedMember.name}</h2>
            {selectedMember.roles.map((role, i) => (
              <p key={i} className="modal-role">{role}</p>
            ))}
            <p className="modal-desc">{selectedMember.desc}</p>
          </motion.div>
        </div>
      )}
    </div>
  );
}
